import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { VisbilitySettingsFragmentDoc } from '../../../../../../../components/Form/components/VisibilitySettings/graphql/fragment/generated/VisibilitySettings';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ActionPlanEditorFocusAreaEntitiesFragment = { id: string, flagOn: Types.FlagOnEntityEnum, flaggedQuestion?: { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum } | null, flaggedTheme?: { id: string, name: string } | null, flaggedMindset?: { id: string, name: string } | null, flaggedSkill?: { id: string, name: string } | null, flaggedSkillGroup?: { _id: string, name: string } | null, performanceReviewMetadata?: Array<{ scoreConfig?: { score: number } | null }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, property?: string | null, value?: string | null, filters: Array<{ operator: Types.FilterOperatorEnum, property: string, value: string }> }> } | null, surveyResponseMetadata?: Array<{ cycleId?: number | null, responseCount?: number | null, participationCount?: number | null, scoreConfig?: { score: number, passiveCount: number, promotersCount: number, detractorsCount: number } | null }> | null };


export type ActionPlanEditorFocusAreaEntitiesFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ActionPlanEditorDetailsFragment = { id: string, name: string, dueDate?: string | null, description?: string | null, focusAreas?: Array<string> | null, parentEntities: Array<string>, owner: { ownerId: string }, actionableTasks?: Array<{ id: string }> | null, focusAreaEntities?: Array<{ id: string, flagOn: Types.FlagOnEntityEnum, flaggedQuestion?: { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum } | null, flaggedTheme?: { id: string, name: string } | null, flaggedMindset?: { id: string, name: string } | null, flaggedSkill?: { id: string, name: string } | null, flaggedSkillGroup?: { _id: string, name: string } | null, performanceReviewMetadata?: Array<{ scoreConfig?: { score: number } | null }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, property?: string | null, value?: string | null, filters: Array<{ operator: Types.FilterOperatorEnum, property: string, value: string }> }> } | null, surveyResponseMetadata?: Array<{ cycleId?: number | null, responseCount?: number | null, participationCount?: number | null, scoreConfig?: { score: number, passiveCount: number, promotersCount: number, detractorsCount: number } | null }> | null }> | null, visibilitySettings?: { groupIds?: Array<string> | null, accessType: Types.VisibilitySettingsAccessTypeEnum, restrictionConfigs?: Array<{ type: Types.VisibilitySettingsRestrictionTypeEnum, entityIds?: Array<string> | null, contextualUserId?: string | null }> | null } | null };


export type ActionPlanEditorDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type ActionPlanEditorDetailsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ActionPlanFilters>;
}>;


export type ActionPlanEditorDetailsQuery = { actionPlan?: { id: string, name: string, dueDate?: string | null, description?: string | null, focusAreas?: Array<string> | null, parentEntities: Array<string>, owner: { ownerId: string }, actionableTasks?: Array<{ id: string }> | null, focusAreaEntities?: Array<{ id: string, flagOn: Types.FlagOnEntityEnum, flaggedQuestion?: { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum } | null, flaggedTheme?: { id: string, name: string } | null, flaggedMindset?: { id: string, name: string } | null, flaggedSkill?: { id: string, name: string } | null, flaggedSkillGroup?: { _id: string, name: string } | null, performanceReviewMetadata?: Array<{ scoreConfig?: { score: number } | null }> | null, filterGroup?: { operator: Types.FilterOperatorEnum, filters: Array<{ operator: Types.FilterOperatorEnum, property?: string | null, value?: string | null, filters: Array<{ operator: Types.FilterOperatorEnum, property: string, value: string }> }> } | null, surveyResponseMetadata?: Array<{ cycleId?: number | null, responseCount?: number | null, participationCount?: number | null, scoreConfig?: { score: number, passiveCount: number, promotersCount: number, detractorsCount: number } | null }> | null }> | null, visibilitySettings?: { groupIds?: Array<string> | null, accessType: Types.VisibilitySettingsAccessTypeEnum, restrictionConfigs?: Array<{ type: Types.VisibilitySettingsRestrictionTypeEnum, entityIds?: Array<string> | null, contextualUserId?: string | null }> | null } | null } | null };

export const ActionPlanEditorFocusAreaEntitiesFragmentDoc = /*#__PURE__*/ gql`
    fragment ActionPlanEditorFocusAreaEntities on FlagSurveyResponseType {
  id
  flagOn
  flaggedQuestion {
    id
    questionText
    questionType
  }
  flaggedTheme {
    id
    name
  }
  flaggedMindset {
    id
    name
  }
  flaggedSkill {
    id
    name
  }
  flaggedSkillGroup {
    _id
    name
  }
  performanceReviewMetadata {
    scoreConfig {
      score
    }
  }
  filterGroup {
    operator
    filters {
      operator
      property
      value
      filters {
        operator
        property
        value
      }
    }
  }
  surveyResponseMetadata {
    cycleId
    responseCount
    participationCount
    scoreConfig {
      score
      passiveCount
      promotersCount
      detractorsCount
    }
  }
}
    `;
export const ActionPlanEditorDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment ActionPlanEditorDetails on ActionPlanType {
  id
  name
  dueDate
  description
  focusAreas
  parentEntities
  owner {
    ownerId
  }
  actionableTasks {
    id
  }
  focusAreaEntities {
    ...ActionPlanEditorFocusAreaEntities
  }
  visibilitySettings {
    ...VisbilitySettings
  }
}
    `;
export const ActionPlanEditorDetailsDocument = /*#__PURE__*/ gql`
    query actionPlanEditorDetails($filters: ActionPlanFilters) {
  actionPlan(filters: $filters) {
    ...ActionPlanEditorDetails
  }
}
    ${ActionPlanEditorDetailsFragmentDoc}
${ActionPlanEditorFocusAreaEntitiesFragmentDoc}
${VisbilitySettingsFragmentDoc}`;

export function useActionPlanEditorDetailsQuery(options?: Omit<Urql.UseQueryArgs<ActionPlanEditorDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<ActionPlanEditorDetailsQuery, ActionPlanEditorDetailsQueryVariables>({ query: ActionPlanEditorDetailsDocument, ...options });
};